import PaymentType from './paymentType.js';

let LuhnCheck = function() {

    let publicMethods = {

        simpleLuhnCheck: function(str) {
            let rv = false;

            let luhnArr = [0, 2, 4, 6, 8, 1, 3, 5, 7, 9];

            // if the length is zero, that means the string only contains digits, dashes or spaces
            if (String(str).replace(/[\d\-\s]/g, "").length == 0) {
                // copy and modify from http://rosettacode.org/wiki/Luhn_test_of_credit_card_numbers
                let counter = 0;
                let incNum;
                let odd = false;
                let temp = String(str).replace(/[^\d]/g, "");

                // change from checking temp.length == 0  (we need at least 13 numbers)
                if (temp.length >= 13) {
                    for (let i = temp.length-1; i >= 0; --i) {
                        incNum = parseInt(temp.charAt(i), 10);
                        odd = !odd;
                        counter += odd ? incNum : luhnArr[incNum];
                    }
                    rv = (counter%10 == 0);
                }
            }

            return rv;
        },

        useLuhn: function(cardType) {
            let rv = true;
            switch (cardType) {
                case PaymentType.AEON:
                case PaymentType.PROV:
                case PaymentType.WIRE:
                case PaymentType.COD:
                case PaymentType.PROPAY:
                case PaymentType.ISRA:
                case PaymentType.ARGE:
                case PaymentType.LCAB:
                case PaymentType.ITAL:
                case PaymentType.TARJ:
                case PaymentType.TARS:
                case PaymentType.CUP:
                case PaymentType.ALIP:
                case PaymentType.IDEA:
                case PaymentType.VIB_WIRE:
                case PaymentType.ACB_WIRE:
                case PaymentType.VCB_WIRE:
                case PaymentType.AGRIBANK_WIRE:
                case PaymentType.CR:
                case PaymentType.MAS:
                case PaymentType.CEDN:
                case PaymentType.PWEB:
                case PaymentType.DBS:
                case PaymentType.UOB:
                case PaymentType.MBB:
                case PaymentType.PBB:
                case PaymentType.CIMB:
                case PaymentType.KBANK:
                case PaymentType.BDO:
                case PaymentType.APVN:
                case PaymentType.KLIK:
                case PaymentType.PERMATA:
                case PaymentType.CITI:
                case PaymentType.HSBC:
                case PaymentType.SDD:
                    rv = false;
                    break;
            }

            return rv;
        },

        isCardNumberMatchingType: function(cardNumber, cardType) {
            // assuming everything is true (even with cardNumber does not contain any digit)
            let rv = true;

            let temp = String(cardNumber).replace(/[^\d]/g, "");
            if (temp.length > 0) {
                switch (cardType) {
                    case 0: // VISA
                        rv = (temp.indexOf("4") == 0);
                        break;
                    case 1: // MC
                        rv = (temp.indexOf("5") == 0  || (temp.indexOf("2") == 0));
                        break;
                    case 2: // DISCOVER
                        rv = (temp.indexOf("300") == 0) || (temp.indexOf("301") == 0)
                        || (temp.indexOf("302") == 0) || (temp.indexOf("303") == 0)
                        || (temp.indexOf("304") == 0) || (temp.indexOf("305") == 0)
                        || (temp.indexOf("309") == 0) || (temp.indexOf("352") == 0)
                        || (temp.indexOf("353") == 0) || (temp.indexOf("354") == 0)
                        || (temp.indexOf("355") == 0) || (temp.indexOf("356") == 0)
                        || (temp.indexOf("357") == 0) || (temp.indexOf("358") == 0)
                        || (temp.indexOf("36") == 0) || (temp.indexOf("38") == 0)
                        || (temp.indexOf("39") == 0) || (temp.indexOf("6011") == 0)
                        || (temp.indexOf("622") == 0) || (temp.indexOf("624") == 0)
                        || (temp.indexOf("625") == 0) || (temp.indexOf("626") == 0)
                        || (temp.indexOf("628") == 0) || (temp.indexOf("644") == 0)
                        || (temp.indexOf("645") == 0) || (temp.indexOf("646") == 0)
                        || (temp.indexOf("647") == 0) || (temp.indexOf("648") == 0)
                        || (temp.indexOf("649") == 0) || (temp.indexOf("65") == 0);
                        break;
                    case 3: // AE
                        rv = (temp.indexOf("34") == 0) || (temp.indexOf("37") == 0);
                        break;
                    case 11: // GCC
                    case 12: // NCC
                        rv = (temp.indexOf("627531") == 0);
                        break;
                    case 15: // ISRA
                        rv = (temp.length == 7);
                        break;
                    case 21: // JCB
                        rv = (temp.indexOf("35") == 0) && (temp.length == 16);
                        break;
                    case 108: // BCA
                        rv = (temp.indexOf("4") == 0) || (temp.indexOf("5") == 0);
                        break;
                }
            }

            return rv;
        },

        luhnCheck: function(cardNumber, cardType) {
            if ((cardType === undefined) || (cardType == null)) {
                return this.simpleLuhnCheck(cardNumber);
            } else if (this.useLuhn(cardType)) {
                return this.isCardNumberMatchingType(cardNumber, cardType) && this.simpleLuhnCheck(cardNumber);
            } else {
                return true;
            }
        }
    };

    return publicMethods;
}();

export default LuhnCheck;
